import type { Session, User } from "@supabase/supabase-js";

import { supabase } from "@/lib/supabase";

// Helper utilities for accessing auth data outside React components.
// Use these in axios interceptors, service classes, or utility functions.

export async function getAccessToken(): Promise<string | null> {
  try {
    const {
      data: { session },
      error,
    } = await supabase.auth.getSession();
    if (error) {
      return null;
    }
    return session?.access_token ?? null;
  } catch (error) {
    return null;
  }
}

export async function getCurrentSession(): Promise<Session | null> {
  try {
    const {
      data: { session },
      error,
    } = await supabase.auth.getSession();
    if (error) {
      return null;
    }
    return session;
  } catch (error) {
    return null;
  }
}

export async function getCurrentUser(): Promise<User | null> {
  try {
    const {
      data: { user },
      error,
    } = await supabase.auth.getUser();
    if (error) {
      return null;
    }
    return user;
  } catch (error) {
    return null;
  }
}

export async function isUserAuthenticated(): Promise<boolean> {
  try {
    const session = await getCurrentSession();
    return !!session;
  } catch (error) {
    return false;
  }
}

// Clear impersonation data from localStorage. Non-React entry point used by
// service code; the hook version (in use-impersonation.ts) also triggers a
// full reload.
export function clearImpersonation(): void {
  if (typeof window !== "undefined") {
    localStorage.removeItem("impersonate_user_id");
    localStorage.removeItem("impersonate_metadata");
  }
}

export function isImpersonating(): boolean {
  if (typeof window === "undefined") return false;
  return !!localStorage.getItem("impersonate_user_id");
}
